/* eslint-disable */
//tslint:disable

import { IBuilderSeoDataSchema } from '../seo/BuilderSeoDataSchema';

export interface IBuilderForListPresenterSchema {
  /** Отображать телефон **/
  displayPhone?: boolean | null;
  /** ID **/
  id: number;
  /** URL логотипа **/
  logoUrl?: string | null;
  /** Статус модерации **/
  moderationStatus?: EModerationStatus | null;
  /** Название **/
  name: string;
  /** Телефон **/
  phone?: string | null;
  /** ЧПУ застройщика **/
  seo?: IBuilderSeoDataSchema | null;
}

export enum EModerationStatus {
  /** Удален **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Новый **/
  New = 'new',
  /** Опубликован **/
  Published = 'published',
}
